import { useSnapshot } from 'valtio'
import { environment } from '../environment'

export const useEnvironment = () => {
  const { env } = useSnapshot(environment)

  return env.status === 'ready' ? env.core : undefined
}
